import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Booking from "@/pages/Booking";
import Confirmation from "@/pages/Confirmation";
import PaymentResult from "@/pages/PaymentResult";
import Review from "@/pages/Review";
import Admin from "@/pages/Admin";
import Voucher from "@/pages/Voucher";
import Cancel from "@/pages/Cancel";
import Blog from "@/pages/Blog";
import Article from "@/pages/Article";
import Mougins from "@/pages/Mougins";
import Partners from "@/pages/Partners";
import { ChatWidget } from "@/components/ChatWidget";
import { LanguageProvider } from "@/i18n";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!window.location.hash) window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const loop = (t) => {
      lenis.raf(t);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Redirections des anciennes URL du site précédent (autorité SEO conservée) */}
          <Route path="/en/home" element={<Navigate to="/" replace />} />
          <Route path="/fr/home" element={<Navigate to="/" replace />} />
          <Route path="/home" element={<Navigate to="/" replace />} />
          <Route path="/en" element={<Navigate to="/" replace />} />
          <Route path="/fr" element={<Navigate to="/" replace />} />
          <Route path="/" element={<Home />} />
          <Route path="/reservation" element={<Booking />} />
          <Route path="/confirmation/:bookingId" element={<Confirmation />} />
          <Route path="/paiement/succes" element={<PaymentResult />} />
          <Route path="/paiement/annule" element={<PaymentResult />} />
          <Route path="/avis/:token" element={<Review />} />
          <Route path="/bon-de-transport/:token" element={<Voucher />} />
          <Route path="/annulation/:token" element={<Cancel />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<Article />} />
          <Route path="/chauffeur-prive-mougins" element={<Mougins />} />
          <Route path="/partenaires" element={<Partners />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <ChatWidget />
        <Toaster richColors position="top-center" />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
